(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cj-collection-intro"] && !Shopify.designMode) return;
  try {
    function classicShapeLinks() {
  document.querySelectorAll('[data-cj-shape]').forEach(link => {
    const url = new URL(window.location.href);
    url.searchParams.delete('filter.p.m.custom.shape');
    url.searchParams.delete('page');
    if (!link.hasAttribute('aria-current')) url.searchParams.set('filter.p.m.custom.shape', link.dataset.cjShape);
    link.href = url.pathname + url.search;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', classicShapeLinks);
else classicShapeLinks();
document.addEventListener('shopify:section:load', classicShapeLinks);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cj-sizing"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const trigger = event.target.closest('[data-cj-sizing]');
  const dialog = document.getElementById('cj-sizing');
  if (trigger && dialog && typeof dialog.showModal === 'function') {
    event.preventDefault();
    if (!dialog.open) dialog.showModal();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const expand = event.target.closest('.menu-sidebar button.menu-dropdwon');
  if (expand) expand.setAttribute('aria-expanded', 'true');
  const back = event.target.closest('.menu-sidebar [data-menu-navbarback]');
  if (back) back.closest('.navbar__item')?.querySelector('button.menu-dropdwon')?.setAttribute('aria-expanded', 'false');
});
  } catch(e) { console.error(e); }
})();

})();
